/** A PD consent link must not navigate the Admin UI to an arbitrary origin. */
export const trustedAvatarConsentUrl = (value: unknown, pdBaseUrl: string): string | null => {
  if (typeof value !== "string") return null;
  try {
    const consent = new URL(value);
    const pd = new URL(pdBaseUrl);
    return consent.origin === pd.origin ? consent.toString() : null;
  } catch {
    return null;
  }
};
